import React from 'react'
import { Image } from 'react-native'

import { B3, H4, SH1, SH3, Stack, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'

import { BrandBenefit, IBrandComsData } from '../../../api/brands/types'

const KeyBenefits = ({
  content,
  brandBenefits,
}: {
  content: IBrandComsData | undefined
  brandBenefits: BrandBenefit[] | undefined
}) => {
  return (
    <Stack className="bg-neutral-white100 -mt-6 rounded-t-2xl px-3 pt-3">
      <H4 className="text-grays-80 mb-2 font-[Graphie-Bold]">
        {content?.name}
      </H4>
      <SH3 className="text-grays-80 mb-3 font-[Graphie-Bold]">
        {i18n.t('productFlow.keyBenefits')}
      </SH3>
      {brandBenefits?.map((item, index) => (
        <Stack key={`${index}+${item?.heading}`} className="mb-3">
          <XStack className="items-center">
            <Image
              source={{ uri: item?.icon }}
              style={{ width: 26, height: 26 }}
            />
            <SH1 className="ml-2 font-[Graphie-Bold]">{item?.tag}</SH1>
          </XStack>
          {item?.subText?.map((text, index) => (
            <B3 className="text-grays-60 mx-4" key={`${index}+${text}`}>
              {text}
            </B3>
          ))}
        </Stack>
      ))}
    </Stack>
  )
}

export { KeyBenefits }
